module.exports = "/assets/797cd674b744b39f2a08e5d3b67be052.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/P6.png
// module id = 2829
// module chunks = 0